import {
    updateAllSampleButtons
  } from './product-samples';
  import { MakeGraphQLQuery } from '../../utils/helpers';
  import { addEventListeners } from './product-samples';
  import { getMetafieldValue } from '../product-showcase/product-showcase';
  import { getProductsByIds } from '../../graphql/product.gql';
  
  export async function getSampleProducts(productIds) {
  const queryStr = getProductsByIds(productIds.map((id) => `"${id}"`));
  
  try {
    const response = await MakeGraphQLQuery(
      `${window.theme.storeURL}/api/2024-01/graphql.json`,
      queryStr
    );
  
    if (response.hasOwnProperty('error')) {
      throw new Error('Failed GraphQL Request');
    }
    const sampleProducts = response.data.nodes;
    return sampleProducts.filter(Boolean);
  } catch (error) {
    console.error('Error fetching samples:', error);
  }
  return [];
  }
  
  const decorateProductCardsWithSampleData = async () => {
    const cards = [...(document.querySelectorAll('.prod-card') || [])];
    const sampleIds = cards.map((card) => card.dataset.sampleId).filter(Boolean);
    const sampleHandles = cards.map((card) => card.dataset.sampleHandle).filter(Boolean);
    const sampleProducts = await getSampleProducts(sampleIds);

    function showAddSamplesButtonIfAble(card) {
      const buttons = card.querySelectorAll('.add-to-samples-cta:not([data-item-unavailable-for-samples])');
      buttons.forEach((button) => {
        button.classList.remove('hide');
      });
    }

    sampleProducts.forEach((product) => {
        const card = document.querySelector(`[data-sample-id="${product.id}"]`);
        if (card) {
            const kit = getMetafieldValue(product.metafields, 'is_sample_kit') === 'true';
            card.dataset.sampleVariantId = product.variants.edges[0].node.id.replace('gid://shopify/ProductVariant/', '');
            card.dataset.sampleHandle = product.handle;
            card.dataset.sampleTags = product.tags || '';
            card.dataset.sampleKit = kit;
            card.dataset.sampleWeight = Number(getMetafieldValue(product.metafields, 'sample_kit_weight') || (kit ? 3 : 1));
            card.dataset.sampleVariantIds = product.variants.edges.map((variant) => variant.node.id.replace('gid://shopify/ProductVariant/', '')).join(',');
            const weightElement = card.querySelector('.prod-card__weight');
            if (weightElement) {
                if (card.dataset.sampleWeight > 1) {
                    weightElement.innerHTML = `Equivalent of ${card.dataset.sampleWeight} Individual Samples`;
                } else {
                    weightElement.innerHTML = '';
                }
            }

            showAddSamplesButtonIfAble(card);
        }
    });

    sampleHandles.forEach((handle) => {
        const card = document.querySelector(`[data-sample-handle="${handle}"]`);
        if (card) {
          showAddSamplesButtonIfAble(card);
        }
    });
    updateAllSampleButtons();
  }
  
  window.decorateProductCardsWithSampleData = decorateProductCardsWithSampleData;
  
  const ProductSamples = () => {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(async () => {
        decorateProductCardsWithSampleData();
      }, 1000);
  
      addEventListeners();
    });
  }
  
  export default ProductSamples;